import isEmpty from 'lodash/isEmpty';

import { enum as promoCategories } from '../../../../../../../../enums/offer-promo-categories';

import http from '../../../../shared/http';
import endpoints from '../../../../../config/endpoints';
import { actions as parentActions } from '../../../editor';

const isRocket = process.env.CPA_ENV === 'rocket';

const createPromoForm = ({
	namespace,
	stateNodeName
}) => {
	// action types
	const UPLOAD_SUCCESS = `${namespace}/${stateNodeName}-upload-success`;
	const UPLOAD_ERROR = `${namespace}/${stateNodeName}-upload-error`;

	const DELETE_ITEM = `${namespace}/${stateNodeName}-delete-item`;

	const SAVE_SUCCESS = `${namespace}/${stateNodeName}-save-success`;
	const SAVE_ERROR = `${namespace}/${stateNodeName}-save-error`;

	const CHANGE_CATEGORY = `${namespace}/${stateNodeName}-change-category`;

	// initState
	const initialState = {
		currentCategory: promoCategories.product,
		isDirty: false
	};

	const actions = {
		uploadFile: (files, nextAction) => (dispatch, getState) => {
			const { offer } = getState().programsEditor;
			const data = new FormData();

			for (let i = 0; i < files.length; i++) {
				const file = files[i];
				data.append(`images[${i}]`, file);
			}

			const request = http({
				url: endpoints.OFFERS.UPLOAD_PROMO.replace('{id}', offer.id),
				method: 'post',
				actions: [
					UPLOAD_SUCCESS,
					UPLOAD_ERROR
				],
				data: data
			});

			dispatch(parentActions.toggleProgressBar());

			request(dispatch);
		},

		promoItemDelete: fileIndex => ({
			type: DELETE_ITEM,
			payload: fileIndex
		}),

		promoSave: () => (dispatch, getState) => {
			const { offer: { id, promo } } = getState().programsEditor;

			const request = http({
				url: `${endpoints.OFFERS.BASE}/${id}`,
				method: 'put',
				actions: [
					SAVE_SUCCESS,
					SAVE_ERROR
				],
				data: {
					promo
				}
			});

			request(dispatch).then(action => {
				if (action.type === SAVE_SUCCESS) {
					dispatch(parentActions.toggleProgressBar());
					dispatch(parentActions.fetchOfferData(id));
				}
			});
		},

		promoChangeCategory: category => ({
			type: CHANGE_CATEGORY,
			payload: category
		})
	};

	// reducers
	const reducers = {
		[SAVE_SUCCESS]: state => ({
			...state,
			promoForm: {
				...state.promoForm,
				isDirty: false
			}
		}),
		[UPLOAD_SUCCESS]: (state, action) => {
			const paths = action.payload.data.map(entity => entity.path);
			const promoCategory = state.promoForm.currentCategory;
			const promo = !isEmpty(state.offer.promo) ? state.offer.promo : {};

			return {
				...state,
				showProgressBar: false,
				promoForm: {
					...state.promoForm,
					isDirty: true
				},
				offer: {
					...state.offer,
					promo: {
						...promo,
						[promoCategory]: promo[promoCategory]
							? [].concat(promo[promoCategory], paths) :
							paths
					}
				}
			};
		},
		[UPLOAD_ERROR]: (state, action) => ({ ...state, error: true, showProgressBar: false }),
		[DELETE_ITEM]: (state, action) => {
			const { offer: { promo }, promoForm: { currentCategory } } = state;

			return {
				...state,
				promoForm: {
					...state.promoForm,
					isDirty: true
				},
				offer: {
					...state.offer,
					promo: {
						...promo,
						[currentCategory]: promo[currentCategory].filter((value, index) => index != action.payload)
					}
				}
			};
		},
		[CHANGE_CATEGORY]: (state, action) => ({
			...state,
			promoForm: {
				...state.promoForm,
				currentCategory: action.payload
			}
		})
	};

	// selectors
	const selectors = {
		getPromoCategories: state => {
			const categories = state.root.lists['offer-promo-categories'];
			const { currentCategory } = state.programsEditor.promoForm;

			const categoryIds = !isRocket
				? [promoCategories.product, promoCategories.documents, promoCategories.banners]
				: [promoCategories.product, promoCategories.creatives];

			return categories.filter((entity) => categoryIds.includes(entity.id)).map(entity => ({
				...entity,
				isActive: entity.id === currentCategory
			}));
		},
		getPromoLinks: state => {
			const promoData = state.programsEditor.offer && state.programsEditor.offer.promo;

			if (!promoData) return [];

			const { currentCategory } = state.programsEditor.promoForm;
			const promo = promoData[currentCategory];
			const allowedToEmbedExtension = ['pdf'];
			const getFileExt = entity => entity.split('.').pop();

			const formatter = entity => {
				const extension = getFileExt(entity);
				const shouldEmbedPdf = allowedToEmbedExtension.indexOf(extension) > -1;

				return {
					file: entity,
					shouldEmbedPdf
				};
			};

			return Array.isArray(promo) ? promo.map(formatter) : [];
		},
		getIsDirty: state => state.programsEditor.promoForm.isDirty
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createPromoForm;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/forms/promo/index.js